import { Dialog } from '../../components/Dialog';
import { renderToStaticMarkup } from 'react-dom/server';

export function generate() {
  return {
    html: renderToStaticMarkup(<Dialog />),
    css: '',
  };
}
